import { useQuery } from "@tanstack/react-query";
import { GET_REVIEWS } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { useSnackbar } from "hooks/useSnackbar";
import { ApiResponseItem } from "api/types";
import IReview from "models/Reviews";
import { IReturnType } from "hooks/types";

export const useGetReviews = () => {
  const { showSnackbar } = useSnackbar();
  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
  }: IReturnType<ApiResponseItem<IReview[]>> = useQuery(
    [GET_REVIEWS],
    () => fetchApi(`reviews`).get(""),
    {
      onSuccess: (data) => {
        showSnackbar("Reviews Fetched Successfully", "success");
      },
      onError: (error) => {
        showSnackbar("Failed to Retrieve Reviews", "error");
      },
    }
  );

  const reviews = response?.data?.items || [];

  return { reviews, isLoading, isError, isFetching, isSuccess, refetch };
};
